// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import image from './image.svg';

interface ImageIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: ImageNames;
}

export function ImageIcon({ name, ...props }: ImageIconProps) {
  return <Icon {...props} link={image} name={name} />
}

type ImageNames =
  | '10mp'
  | '11mp'
  | '12mp'
  | '13mp'
  | '14mp'
  | '15mp'
  | '16mp'
  | '17mp'
  | '18mp'
  | '19mp'
  | '20mp'
  | '21mp'
  | '22mp'
  | '23mp'
  | '24mp'
  | '2mp'
  | '30fps_select'
  | '3mp'
  | '4mp'
  | '5mp'
  | '60fps_select'
  | '6mp'
  | '7mp'
  | '8mp'
  | '9mp'
  | 'add_a_photo'
  | 'add_photo_alternate'
  | 'add_to_photos'
  | 'adjust'
  | 'animation'
  | 'assistant_photo'
  | 'assistant'
  | 'audiotrack'
  | 'auto_awesome_mosaic'
  | 'auto_awesome_motion'
  | 'auto_awesome'
  | 'auto_fix_high'
  | 'auto_fix_normal'
  | 'auto_fix_off'
  | 'auto_stories'
  | 'autofps_select'
  | 'bedtime_off'
  | 'bedtime'
  | 'blur_circular'
  | 'blur_linear'
  | 'blur_off'
  | 'blur_on'
  | 'brightness_1'
  | 'brightness_2'
  | 'brightness_3'
  | 'brightness_4'
  | 'brightness_5'
  | 'brightness_6'
  | 'brightness_7'
  | 'broken_image'
  | 'brush'
  | 'burst_mode'
  | 'camera_alt'
  | 'camera_front'
  | 'camera_rear'
  | 'camera_roll'
  | 'camera'
  | 'cases'
  | 'center_focus_strong'
  | 'center_focus_weak'
  | 'circle'
  | 'collections_bookmark'
  | 'collections'
  | 'color_lens'
  | 'colorize'
  | 'compare'
  | 'contrast'
  | 'control_point_duplicate'
  | 'control_point'
  | 'crop_16_9'
  | 'crop_3_2'
  | 'crop_5_4'
  | 'crop_7_5'
  | 'crop_din'
  | 'crop_free'
  | 'crop_landscape'
  | 'crop_original'
  | 'crop_portrait'
  | 'crop_rotate'
  | 'crop_square'
  | 'crop'
  | 'currency_bitcoin'
  | 'currency_franc'
  | 'currency_lira'
  | 'currency_pound'
  | 'currency_ruble'
  | 'currency_rupee'
  | 'currency_yen'
  | 'currency_yuan'
  | 'deblur'
  | 'dehaze'
  | 'details'
  | 'dirty_lens'
  | 'edit'
  | 'euro'
  | 'exposure_neg_1'
  | 'exposure_neg_2'
  | 'exposure_plus_1'
  | 'exposure_plus_2'
  | 'exposure_zero'
  | 'exposure'
  | 'face_retouching_natural'
  | 'face_retouching_off'
  | 'filter_1'
  | 'filter_2'
  | 'filter_3'
  | 'filter_4'
  | 'filter_5'
  | 'filter_6'
  | 'filter_7'
  | 'filter_8'
  | 'filter_9_plus'
  | 'filter_9'
  | 'filter_b_and_w'
  | 'filter_center_focus'
  | 'filter_drama'
  | 'filter_frames'
  | 'filter_hdr'
  | 'filter_none'
  | 'filter_tilt_shift'
  | 'filter_vintage'
  | 'filter'
  | 'flare'
  | 'flash_auto'
  | 'flash_off'
  | 'flash_on'
  | 'flip_camera_android'
  | 'flip_camera_ios'
  | 'flip'
  | 'gradient'
  | 'grain'
  | 'grid_off'
  | 'grid_on'
  | 'hdr_enhanced_select'
  | 'hdr_off'
  | 'hdr_on'
  | 'hdr_plus'
  | 'hdr_strong'
  | 'hdr_weak'
  | 'healing'
  | 'hevc'
  | 'hide_image'
  | 'image_aspect_ratio'
  | 'image_not_supported'
  | 'image_search'
  | 'image'
  | 'incomplete_circle'
  | 'iso'
  | 'landscape'
  | 'leak_add'
  | 'leak_remove'
  | 'lens'
  | 'linked_camera'
  | 'logo_dev'
  | 'looks_3'
  | 'looks_4'
  | 'looks_5'
  | 'looks_6'
  | 'looks_one'
  | 'looks_two'
  | 'looks'
  | 'loupe'
  | 'mic_external_off'
  | 'mic_external_on'
  | 'monochrome_photos'
  | 'motion_photos_auto'
  | 'motion_photos_off'
  | 'motion_photos_on'
  | 'motion_photos_pause'
  | 'motion_photos_paused'
  | 'movie_creation'
  | 'movie_filter'
  | 'mp'
  | 'music_note'
  | 'music_off'
  | 'nature_people'
  | 'nature'
  | 'navigate_before'
  | 'navigate_next'
  | 'palette'
  | 'panorama_fish_eye'
  | 'panorama_horizontal_select'
  | 'panorama_horizontal'
  | 'panorama_photosphere_select'
  | 'panorama_photosphere'
  | 'panorama_vertical_select'
  | 'panorama_vertical'
  | 'panorama_wide_angle_select'
  | 'panorama_wide_angle'
  | 'panorama'
  | 'photo_album'
  | 'photo_camera_back'
  | 'photo_camera_front'
  | 'photo_camera'
  | 'photo_filter'
  | 'photo_library'
  | 'photo_size_select_actual'
  | 'photo_size_select_large'
  | 'photo_size_select_small'
  | 'photo'
  | 'picture_as_pdf'
  | 'portrait'
  | 'raw_off'
  | 'raw_on'
  | 'receipt_long'
  | 'remove_red_eye'
  | 'rotate_90_degrees_ccw'
  | 'rotate_90_degrees_cw'
  | 'rotate_left'
  | 'rotate_right'
  | 'shutter_speed'
  | 'slideshow'
  | 'straighten'
  | 'style'
  | 'switch_camera'
  | 'switch_video'
  | 'tag_faces'
  | 'texture'
  | 'thermostat_auto'
  | 'timelapse'
  | 'timer_10'
  | 'timer_3'
  | 'timer_off'
  | 'timer'
  | 'tonality'
  | 'transform'
  | 'tune'
  | 'video_camera_back'
  | 'video_camera_front'
  | 'video_stable'
  | 'view_comfy'
  | 'view_compact'
  | 'vignette'
  | 'vrpano'
  | 'wb_auto'
  | 'wb_cloudy'
  | 'wb_incandescent'
  | 'wb_iridescent'
  | 'wb_shade'
  | 'wb_sunny'
  | 'wb_twilight'
;

